import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import api from "../../../../services/api";
import PageHeader from "../../../components/Pageheader";

export default function AdicionaOcorrencia() {
  const history = useHistory();
  const [nomeOcorrencia, setNomeOcorrencia] = useState("");
  const [abono, setAbono] = useState(false);
  const [exigeCidCrm, setExigeCidCrm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erros, setErros] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [showModal, setShowModal] = useState(false);

  async function adicionaOcorrencia(e) {
    e.preventDefault();
    if (!nomeOcorrencia) {
      handleModal(false, "Por favor, digite um nome para a ocorrência");
    } else {
      setLoading(true);
      api
        .post("tipoOcorrencias", { nomeOcorrencia, abono, exigeCidCrm })
        .then((res) => {
          console.log(res.data);
          handleModal(true);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          handleModal(false);
          setLoading(false);
        });
    }
  }

  function handleModal(
    sucess,
    msg = "Falha ao criar a ocorrência. Tente novamente"
  ) {
    if (sucess) {
      setMensagem("Ocorrência criada com sucesso");
    } else {
      setErros(true);
      setMensagem(msg);
    }
    setShowModal(true);
  }

  function handleCloseModal() {
    if (erros) {
      setShowModal(false);
      setErros(false);
    } else {
      history.push("/dashboard/escala/tipoOcorrencia");
    }
  }
  return (
    <div>
      <PageHeader titulo="Editar Tipo de Ocorrência" hasButton={false} />
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {/* <h4 className="card-title">Editar Tipo de Ocorrência</h4> */}
              {/* <p className="card-description"> Basic form elements </p> */}

              <form className="forms-sample">
                <div className="row">
                  <div div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="emailInput">Tipo de Ocorrência</label>
                      <Form.Control
                        value={nomeOcorrencia}
                        onChange={(e) => setNomeOcorrencia(e.target.value)}
                        disabled={loading}
                        type="text"
                        className="form-control"
                        id="emailInput"
                        placeholder="Digite o nome da ocorrência"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div div className="col-md-6">
                    <Form.Group>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            onChange={() => setAbono(!abono)}
                            disabled={loading}
                            type="checkbox"
                            className="form-check-input"
                          />
                          <i className="input-helper"></i>
                          Abone
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input
                            onChange={() => setExigeCidCrm(!exigeCidCrm)}
                            disabled={loading}
                            type="checkbox"
                            className="form-check-input"
                          />
                          <i className="input-helper"></i>
                          Exige Cid / Cim
                        </label>
                      </div>
                    </Form.Group>
                  </div>
                </div>
                {loading ? (
                  <button
                    disabled={true}
                    type="submit"
                    className="btn btn-primary mr-2"
                  >
                    Envaindo
                  </button>
                ) : (
                  <button
                    onClick={adicionaOcorrencia}
                    type="submit"
                    className="btn btn-primary mr-2"
                  >
                    Salvar
                  </button>
                )}
                {!loading && (
                  <button
                    onClick={() =>
                      history.push(`/dashboard/escala/tipoOcorrencia`)
                    }
                    className="btn btn-light"
                  >
                    Cancelar
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Mensagem</Modal.Title>
          </Modal.Header>
          <Modal.Body>{mensagem}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCloseModal}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
